export const COORD_PARIS = {
	lat: '48.866667',
	lng: '2.333333'
}
export const FORM_ID = 'formDossier'